module.exports = __webpack_public_path__ + "assets/img/5-raisons-transformer-bureau-sans-papier.73dc0b43.jpg";